import { RudderAnalytics } from "@rudderstack/analytics-js";

export const analytics = new RudderAnalytics();

export interface TrackingService {
  trackEvent: (eventName: string, properties?: Record<string, any>) => void;
}

export const trackingService: TrackingService = {
  trackEvent: (eventName: string, properties?: Record<string, any>) => {
    analytics.track(eventName, properties);
  }
};
